import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import {
  browserCookieIdExperiments,
  userIdExperiments
} from '~/constants/home/experiments';
import { useUserIsImpersonating } from '~/context/common/UserContext';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import useEventExperiments from '~/hooks/common/telemetry/useEventExperiments';
import useSendFeatureBranchToDataDog from '~/hooks/common/telemetry/useSendFeatureBranchToDataDog';
import useSendNativeDeviceTypeToDataDog from '~/hooks/common/telemetry/useSendNativeDeviceTypeToDataDog';

const useSetDataDogContext = () => {
  const isReturningUser = useGetIsReturnUser();
  const isImpersonating = useUserIsImpersonating();
  useEventExperiments(browserCookieIdExperiments, userIdExperiments);
  useSendFeatureBranchToDataDog();
  useSendNativeDeviceTypeToDataDog();

  useEffect(() => {
    datadogRum.setGlobalContextProperty('isImpersonating', isImpersonating);
    datadogRum.setGlobalContextProperty('isReturningUser', isReturningUser);
  }, [isImpersonating, isReturningUser]);
};

export default useSetDataDogContext;
